import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import TextAvatar from "components/avatar/TextAvatar";
import { cleanName } from "config/helpers/common_helper";
import {
  set_show_popup,
  set_show_zoom_popup,
} from "redux/actions/ScribeAcitons";
import { Logout } from "@mui/icons-material";
import Confirmation from "components/ui/ConfirmationDialog/ConfirmationDialog";
import _, { isEqual } from "lodash";
import { useEffect, useMemo, useState } from "react";
import {
  change_app_language,
  change_login,
  reset_state,
} from "redux/actions/AppActions";
import { constants } from "redux/constants/redux-constants";
import { activeStatus, getCurrentPlan } from "screens/store/storeHelper";
import UIButton from "components/ui/form/UIButton";
import { FeedBackIcon, ReferFriendIcon } from "assets/icons/ProfileIcons";
import { toast } from "react-toastify";
import TypeformEmbed from "components/feedback/TypeformEmbed";
import { LOGOUT_FROM_SERVER } from "adapters/auth.service";
import specialityOptions from "config/helpers/specialityData.json";
import { stopAllPollingTasks } from "redux/redux-thunk/BackgroundtaskThunks";
import { removeActiveTasks, set_show_task_inprogress_popup } from "redux/actions/BackgroundTaskActions";
import { reset_subscription } from "redux/actions/SubscriptionAction";
import { getCurrentProgressState } from "config/helpers/progressStateSelector";
import { getCurrentRecordingState } from "config/helpers/recordingStateSelector";

const ProfileModal = ({ open, onClose }) => {
  const reduxDispatch = useDispatch();
  const zoomCallOngoing = useSelector(
    (state) => state?.recognizer?.zoomCallOngoing
  );

  const app = useSelector((state) => state.app, isEqual);
  const [openAlert, setOpenAlert] = useState();
  const theme = useSelector((state) => state?.app?.theme);
  const practitionerData = useSelector(
    (state) => state?.auth?.practitionerData
  );
  const personData = useSelector((state) => state?.auth?.personData);
  const currentUserPracticeData = useSelector(
    (state) => state?.auth?.currentUserPracticeData
  );
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const loggedInUserData = useSelector((state) => state?.auth?.userData);
  const userFirstname = personData?.name?.[0]?.text
    ?.split(" ")
    ?.slice(0, 2)
    ?.join(" ");
  const navigateTo = (path) => {
    onClose();
    navigate(path);
  };
  const showTaskInProgressPopup = useSelector((state) => state?.backgroundTasks?.showTaskInProgressPopup);
  const backgroundTasks = useSelector((state) => state.backgroundTasks.tasks);
  const [loading, setLoading] = useState(false);
  const isBackgroundTasks = backgroundTasks.some(
    (t) => t.status === "IN_PROGRESS" || t.status === "PENDING"
  );
  const patientObj = useSelector((state) => state?.patientObj);
  const encounterObj = useSelector((state) => state?.encounterObj);
  const activeGenerations = useSelector(
    (state) => state.activeSOAPGeneration?.activeGenerations
  );

  const { recording: isRecording, paused: isPaused } = useSelector((state) =>
    getCurrentRecordingState(state, patientObj?.patientObj?.id, encounterObj?.encounter?.id)
  );
  const progressState = useSelector((state) =>
    getCurrentProgressState(state, patientObj?.patientObj?.id, encounterObj?.encounter?.id, activeGenerations)
  );
  const { isProgressReady } = progressState || {};

  console.log("name", userFirstname);
  function getSpecialtyLabel(code) {
    const specialty = specialityOptions.find((item) => item.value === code);
    return specialty ? specialty.label : null;
  }

  const [triggerFeedback, setTriggerFeedback] = useState(false);

  const handleFeedbackClick = () => {
    if ((isRecording || isPaused) && !isProgressReady) {
      reduxDispatch(set_show_popup(true, () => setTriggerFeedback(true)));
    } else if (zoomCallOngoing) {
      reduxDispatch(set_show_zoom_popup(true));
    } else {
      setTriggerFeedback(true);
    }
  };

  console.log("data", practitionerData);

  const isSubscriptionExpired = useSelector(
    (state) =>
      state?.license?.package?.license !== "TRIAL" &&
      !activeStatus?.includes(state?.license?.plan_status)
  );

  const handleLogout = async () => {
    try {
      setLoading(true);
      const language = app?.language;
      let response = await LOGOUT_FROM_SERVER();
      reduxDispatch(change_login(constants?.USER_LOGOUT));
      reduxDispatch(reset_state());
      reduxDispatch(change_app_language(language || "en"));
      reduxDispatch(stopAllPollingTasks());
      reduxDispatch(removeActiveTasks());
      reduxDispatch(reset_state());
      reduxDispatch(reset_subscription());
      reduxDispatch({
        type: constants.RECOGNIZER.RESET_RECOGNIZER,
      });
      reduxDispatch({
        type: constants.ACTIVE_SOAP_GENERATION.CLEAR_ALL_ACTIVE_SOAP_GENERATIONS,
      });
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const isMobile = useMediaQuery("(max-width:768px)");

  const handleClick = () => {
    if (isProgressReady) {
      reduxDispatch(set_show_task_inprogress_popup(true));
    }
    else if (isRecording || isPaused) {
      reduxDispatch(set_show_popup(true, () => setOpenAlert(true)));
    } else if (zoomCallOngoing) {
      reduxDispatch(set_show_zoom_popup(true));
    } else if (isBackgroundTasks) {
      reduxDispatch(set_show_task_inprogress_popup(true));
    } else {
      setOpenAlert(true);
    }
  };

  const handleReferFriendClick = () => {
    toast.info(`${i18n.t("profile_card.COMING_SOON")}`);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      {openAlert && (
        <Confirmation
          open={openAlert}
          setOpen={setOpenAlert}
          title={i18n.t(`Side_Menu.SIGN_OUT?`)}
          message={i18n.t(`Side_Menu.LOGOUT_ALERT`)}
          callback={handleLogout}
          autoFocus={"cancel"}
          cancelFunction={() => setOpenAlert(false)}
          loading={loading}
        />
      )}
      {showTaskInProgressPopup && (
        <Confirmation
          open={showTaskInProgressPopup}
          title={i18n.t(`Side_Menu.SIGN_OUT?`)}
          setOpen={() => reduxDispatch(set_show_task_inprogress_popup(false))}
          message={i18n.t(`Side_Menu.TASK_IN_PROGRESS_SIGNOUT_WARNING`)}
          callback={handleLogout}
          autoFocus={"cancel"}
          loading={loading}
        />
      )}
      <Box
        sx={{
          position: "fixed",
          top: "64px",
          right: "2rem",
        }}
      >
        <Paper
          sx={{
            minHeight: "200px",
            borderRadius: "8px",
            background: theme === "dark" ? "#474586" : "",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              gap: "2px",
              padding: "24px 60px 0px 60px",
            }}
          >
            <TextAvatar
              text={userFirstname}
              sx={{
                marginRight: "0px",
                height: isMobile ? "4dvh" : "3.44vw",
                width: isMobile ? "4dvh" : "3.44vw",
                borderRadius: "50%",
                fontSize: isMobile ? "12px" : "1.5vw",
                padding: "1.6vw",
                marginBottom: "1vw",
              }}
            />
            <Typography
              sx={{
                marginBottom: "0.6vw",
                fontSize: isMobile ? "1.7dvh" : "1.2vw",
                fontWeight: "medium",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {cleanName(personData?.name?.[0]?.text)}
            </Typography>
            <Typography
              sx={{
                marginBottom: "0.6vw",
                fontSize: isMobile ? "1.7dvh" : "0.9vw",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {currentUserPracticeData?.practiceData?.isFirstVisitSkipped
                ? ""
                : practitionerData?.qualification?.[0]?.code?.coding?.[0]
                  ?.display === "Other"
                  ? `${i18n.t(`SPECIALTY.OTHER`)} - ${practitionerData?.qualification?.[0]?.code?.coding?.[0]
                    ?.code
                  }`
                  : i18n.t(
                    `SPECIALTY.${getSpecialtyLabel(
                      practitionerData?.qualification?.[0]?.code?.coding?.[0]
                        ?.code
                    )}`
                  ) ||
                  practitionerData?.qualification?.[0]?.code?.coding?.[0]
                    ?.display}
            </Typography>
            <Button
              sx={{
                background: "#fff",
                fontSize: isMobile ? "1.5dvh" : "min(1.17vw,0.8vw)",
                minWidth: "9.7vw",
                padding: isMobile ? "0.6dvh 1.2dvh" : "0.1vw 0px",
                borderRadius: "36px",
                "&:hover": { background: "#D3D3D3" },
                border: theme === "light" ? "1px solid blue" : "",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => {
                debugger
                if ((isRecording || isPaused) && !isProgressReady) {
                  reduxDispatch(set_show_popup(true, "/settings/me"));
                  onClose();
                } else if (zoomCallOngoing) {
                  reduxDispatch(set_show_zoom_popup(true));
                } else {
                  navigateTo("/settings/profile");
                }
              }}
            >
              {i18n.t("profile.VIEW_PROFILE")}
            </Button>
          </Box>

          <Box sx={{ padding: isMobile ? "2.5vw" : "1vw" }}>
            <Box
              sx={{
                border: "1px solid #9A8F8F4D",
                width: "100%",
                margin: "5px 0",
              }}
            />

            <Box
              sx={{
                padding: "0px",
                width: "100%",
                gap: 2,
              }}
            >
              <Box
                className="d-flex align-items-center gap-2"
                sx={{
                  cursor: "pointer",
                  justifyContent: "flex-start",
                  width: "100%",
                  padding: "10px 0",
                  marginTop: "0.7vw",
                }}
                onClick={handleFeedbackClick}
              >
                <FeedBackIcon sx={{ width: "24px", height: "24px" }} />
                <span style={{ marginLeft: "8px", flex: 1 }}>
                  {i18n.t("profile_card.FEEDBACK")}
                </span>
                <TypeformEmbed
                  triggerFeedback={triggerFeedback}
                  setTriggerFeedback={setTriggerFeedback}
                />
              </Box>

              <Box
                sx={{
                  border: "1px solid #9A8F8F4D",
                  width: "100%",
                }}
              />

              <Box
                className="d-flex align-items-center gap-2"
                sx={{
                  cursor: "pointer",
                  justifyContent: "flex-start",
                  width: "100%",
                  padding: "10px 0",
                }}
              >
                <ReferFriendIcon sx={{ width: "24px", height: "24px" }} />
                <span
                  style={{ marginLeft: "8px", flex: 1 }}
                  onClick={handleReferFriendClick}
                >
                  {i18n.t("profile_card.REFER_A_FRIEND")}
                </span>
              </Box>

              <Box
                sx={{
                  border: "1px solid #9A8F8F4D",
                  width: "100%",
                }}
              />

              <Box
                className="d-flex align-items-center gap-2"
                sx={{
                  cursor: "pointer",
                  justifyContent: "flex-start",
                  width: "100%",
                  color: "red",
                  padding: "10px 0",
                }}
                onClick={handleClick}
              >
                <Logout
                  sx={{ width: "24px", height: "24px", marginRight: "8px" }}
                />
                <span>{i18n.t("Side_Menu.Sign_out")}</span>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Dialog>
  );
};

export default ProfileModal;
